export * as palette from "./palette";
export * from "./units";
export * as typography from "./typography";

export const boxShadow = "0px 4px 20px rgba(33, 33, 33, 0.1)";
